import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ExternalLinkService {
    public isExternal(href?: string): boolean {
        if (!href) {
            return false;
        }

        return !href.startsWith('/')
            || href.startsWith('/public-forms/downloads/')
            || href.startsWith('/sites/big-direkt-de/files');
    }

    public isPhoneNumber(href: string): boolean {
        return /(tel|fax):\d+/.test(href);
    }

    public getRel(isExternal: boolean): string {
        if(isExternal) {
            return 'nofollow noopener';
        }

        return 'follow';
    }

    public getTarget(isExternal: boolean): '_blank' | '_self' {
        if(isExternal) {
            return '_blank';
        }

        return '_self';
    }
}
